import React__default from 'react';
import getQuantityListComponentBySkin from './components/option-skins/index.mjs';
import { QuantityDropdown } from './components/option-skins/wide/quantity-dropdown.mjs';
import '../../../../../../../lodash.clonedeep/index.mjs';
import '../../product-option/context/product-option-context.mjs';
import '../../product-option/context/validators/description-validator.mjs';
import '../../product-options-translations/product-option-translations.mjs';
import { useProductOptionContext } from '../../product-option/context/use-product-option-context.mjs';

const QuantityListOptions = (props) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const onChangeHandler = (event) => {
        props.onChanged(event);
    };
    const { uiDensityQuantityUpdate } = useProductOptionContext();
    if (uiDensityQuantityUpdate && props.option.choices.length > 12) {
        return React__default.createElement(QuantityDropdown, { ...props });
    }
    const QuantityListComponent = getQuantityListComponentBySkin(props.skin ?? "wide");
    const quantityListProps = {
        ...props,
        onChanged: onChangeHandler,
    };
    return React__default.createElement(QuantityListComponent, { ...quantityListProps });
};

export { QuantityListOptions };
//# sourceMappingURL=quantity-list-options.mjs.map
